import React from 'react'
import { Popup, Button } from 'semantic-ui-react'

/**
 * @param {object} props
 * @param {(e, data) => void} props.onDelete
 * @param {boolean} props.loading
 * @param {string=} props.title
 * @param {string=} props.description
 * @param {string} props.actionButtonLabel
 * @param {import('react').ReactElement} props.children
 */
export default function DeleteConfirmationButton({
  onDelete,
  loading,
  title,
  description,
  actionButtonLabel,
  children,
}) {
  return (
    <Popup basic trigger={children} position="bottom left" on="click" wide>
      {title && <Popup.Header>{title}</Popup.Header>}
      <Popup.Content>
        {description && <p>{description}</p>}
        <Button negative fluid loading={loading} disabled={loading} onClick={onDelete}>
          {actionButtonLabel}
        </Button>
      </Popup.Content>
    </Popup>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/DeleteConfirmationButton/index.js